import { createContext } from 'react';

export type CSSVariables = {
	[variableName: string]: string | number | undefined;
};

export type CSSProps = {
	[targetSelector: string]: React.CSSProperties | undefined;
};

export type ChangeCSSPropsFn = (
	selector: string,
	css: React.CSSProperties
) => void;

export type ChangeCSSVariableFn = (
	variableName: string,
	variableValue: string | number
) => void;

export type StyleContextData = {
	CSSProps?: CSSProps;
	changeCSSProps?: ChangeCSSPropsFn;
	CSSVariables?: CSSVariables;
	changeCSSVariables?: ChangeCSSVariableFn;
	rootCSSVariables?: CSSVariables;
	changeRootCSSVariables?: ChangeCSSVariableFn;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const StyleContext = createContext<StyleContextData>(null);

export default StyleContext;
